import { render, staticRenderFns } from "./They-Said-pc.vue?vue&type=template&id=75f7d676&scoped=true"
import script from "./They-Said-pc.vue?vue&type=script&lang=js"
export * from "./They-Said-pc.vue?vue&type=script&lang=js"
import style0 from "./They-Said-pc.vue?vue&type=style&index=0&id=75f7d676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f7d676",
  null
  
)

export default component.exports